// Initialisation de l'objet queryParams pour stocker les paramètres de requête
Shopify.queryParams = {};

/*********************************************************************************************
* Refresh the collection page with the provided filters.
	* 
	* @param {string} url_filters - The URL parameters for the filters.
*/
function refreshCollectionPageWithFilters(url_filters) {
    let currentUrl = '//' + location.host + location.pathname;
    let newPageString = httpGet(`${currentUrl}?${url_filters}&section_id=${returnShopifySectionIdShort()}`);
    
    // Créer un nouvel élément DIV pour insérer le HTML récupéré
    let newPageEl = document.createElement('DIV');
    newPageEl.innerHTML = newPageString;

    // Mise à jour des articles de la collection avec les nouveaux filtres
    var newSection = newPageEl.querySelector('.mm-collection-grid');
    document.querySelector('.mm-collection-grid').innerHTML = newSection.innerHTML;
    
    // Mise à jour des autres éléments avec la classe 'mm-reload'
    var reloadElems = newPageEl.querySelectorAll('.mm-reload');
    reloadElems.forEach(function (reloadElem, index) {
        var newElems = document.querySelectorAll('.mm-reload');
        newElems[index].innerHTML = reloadElem.innerHTML;
    });

    // Mise à jour de l'URL dans l'historique sans recharger la page
    window.history.replaceState(null, document.title, currentUrl + '?' + url_filters);
    document.querySelector('.mm-collection-grid').classList.remove('loading');
    
    // Vérifie les changements dans les filtres après le rafraîchissement
    checkForChanges();

    // Relance les sliders des product cards
    mmSetupProductCardsSplides();
    
    // Reset infinite scroll after filter changes
    if (mmInfiniteScroll) {
        mmInfiniteScroll.reset();
    }
}

/*********************************************************************************************
* Return the Shopify section ID of the collection grid.
	* 
	* @returns {string} - The section ID of the grid.
*/
function returnShopifySectionId() {
    const gridElem = document.querySelector('.mm-collection-grid');
    const gridSection = gridElem.closest('.shopify-section');
    return gridSection.id;
}

/*********************************************************************************************
* Return the Shopify section ID without the 'shopify-section-' prefix.
	* 
	* @returns {string} - The shortened section ID.
*/
function returnShopifySectionIdShort() {
    return returnShopifySectionId().replace('shopify-section-', '');
}

/*********************************************************************************************
* Perform a synchronous GET request.
	* 
	* @param {string} theUrl - The URL to request.
	* @returns {string} - The response text from the request.
*/
function httpGet(theUrl) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open('GET', theUrl, false);  // Synchronous request
    xmlHttp.send(null);
    return xmlHttp.responseText;
}

/*********************************************************************************************
* Check for changes in the filter inputs and submit the form if changes are detected.
	*	
*/
function checkForChanges() {
    var form = document.getElementById('collectionFacetsForm');
    var inputs = form.querySelectorAll('input');

    // Ajouter un listener sur chaque input pour détecter les changements
    inputs.forEach(function (input) {
        input.addEventListener('change', function () {
            fakeSubmitForm();
        });
    });
}


/*********************************************************************************************
* Update the sort_by query parameter and reload the page with the new sorting applied.
	* 
	* @param {HTMLSelectElement} select - The select element for sorting.
*/
function mmSortByChanged(select) {
    const hiddenSelect = document.getElementById('mmSortByHiddenElem');
    hiddenSelect.value = select.value;
    fakeSubmitForm();
}

/*********************************************************************************************
* Serialize the form data and refresh the collection page with the filters.
	*
*/
function fakeSubmitForm() {
    let form = document.getElementById("collectionFacetsForm");
    let url_filters = new URLSearchParams(new FormData(form)).toString();
    document.querySelector('.mm-collection-grid').classList.add('loading');
    
    // Rafraîchir la collection avec les filtres
    setTimeout(() => {
        refreshCollectionPageWithFilters(url_filters);
    }, "0");
}
    
/*********************************************************************************************
* Open the mobile filters drawer.
    *
*/
function mmOpenFiltersMobile() {
    const wrapperMobile = document.querySelector('.mm-collection-filters-wrapper');
    const header = document.querySelector('.mm-section-announcement-bar');

    wrapperMobile.classList.add('mm-open');
    document.querySelector('html').classList.add('stop-scrolling');  // Empêche le scroll en arrière-plan
    header.style.zIndex = "12";
}

/*********************************************************************************************
* Close the mobile filters drawer.
    *
*/
function mmCloseFiltersMobile() {
    const wrapperMobile = document.querySelector('.mm-collection-filters-wrapper');
    const header = document.querySelector('.mm-section-announcement-bar');

    wrapperMobile.classList.remove('mm-open');
    document.querySelector('html').classList.remove('stop-scrolling');  // Réactive le scroll
    header.style.zIndex = "13";
}

/*********************************************************************************************
* Check if the URL contains the 'open_filters' parameter and open the mobile filters drawer if it does.
    * 
*/
function mmCheckDrawer() {
    var currentUrl = document.location.href.indexOf('?open_filters');
    if (currentUrl !== -1) {
        mmOpenFiltersMobile();
    }
}

/*********************************************************************************************
* Infinite Scroll Implementation
	*
*/
class MMInfiniteScroll {
    constructor() {
        this.grid = document.querySelector('.mm-collection-grid');
        this.loadingIndicator = document.querySelector('.mm-infinite-scroll-loading');
        this.endIndicator = document.querySelector('.mm-infinite-scroll-end');
        this.fallbackPagination = document.querySelector('.mm-fallback-pagination');
        this.isLoading = false;
        this.currentPage = parseInt(this.grid?.dataset.currentPage) || 1;
        this.totalPages = parseInt(this.grid?.dataset.totalPages) || 1;
        this.productsPerPage = 40; // Should match pagination_nbr in liquid
        this.scrollThreshold = 200; // pixels from bottom to trigger load
        
        this.init();
    }

    init() {
        if (!this.grid || this.currentPage >= this.totalPages) {
            this.hideFallbackPagination();
            return;
        }

        // Hide fallback pagination when infinite scroll is active
        this.hideFallbackPagination();
        
        // Setup scroll listener
        this.setupScrollListener();
        
        // Check if we need to restore position from URL hash
        this.checkForPositionRestore();
    }

    hideFallbackPagination() {
        if (this.fallbackPagination) {
            this.fallbackPagination.style.display = 'none';
        }
    }

    setupScrollListener() {
        let timeout;
        window.addEventListener('scroll', () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                this.handleScroll();
            }, 100);
        });
    }

    handleScroll() {
        if (this.isLoading || this.currentPage >= this.totalPages) {
            return;
        }

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;

        if (scrollTop + windowHeight >= documentHeight - this.scrollThreshold) {
            this.loadNextPage();
        }
    }

    async loadNextPage() {
        if (this.isLoading || this.currentPage >= this.totalPages) {
            return;
        }

        this.isLoading = true;
        this.showLoadingIndicator();

        try {
            const nextPage = this.currentPage + 1;
            const currentUrl = new URL(window.location);
            currentUrl.searchParams.set('page', nextPage);
            currentUrl.searchParams.set('section_id', returnShopifySectionIdShort());

            const response = await fetch(currentUrl.toString());
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            const newGrid = doc.querySelector('.mm-collection-grid');
            if (newGrid) {
                // Update product positions for new products
                const newProducts = newGrid.querySelectorAll('.mm-product-card-wrapper');
                newProducts.forEach((product, index) => {
                    const globalIndex = (this.currentPage - 1) * this.productsPerPage + index;
                    const pagePosition = `${this.currentPage}-${index}`;
                    product.dataset.productPosition = globalIndex;
                    product.dataset.pagePosition = pagePosition;
                    
                    // Update all links in this product card
                    const links = product.querySelectorAll('a[href*="' + product.querySelector('a').href.split('/').pop() + '"]');
                    links.forEach(link => {
                        const baseUrl = link.href.split('#')[0];
                        link.href = baseUrl + '#page-' + pagePosition;
                    });
                });

                // Append new products to existing grid
                this.grid.innerHTML += newGrid.innerHTML;
                this.currentPage = nextPage;

                // Update grid data attributes
                this.grid.dataset.currentPage = this.currentPage;

                // Reinitialize product card sliders for new products
                mmSetupProductCardsSplides();

                // Hide loading indicator
                this.hideLoadingIndicator();

                // Check if we've reached the end
                if (this.currentPage >= this.totalPages) {
                    this.showEndIndicator();
                }
            }
        } catch (error) {
            console.error('Error loading next page:', error);
            this.hideLoadingIndicator();
        } finally {
            this.isLoading = false;
        }
    }

    showLoadingIndicator() {
        if (this.loadingIndicator) {
            this.loadingIndicator.style.display = 'block';
        }
    }

    hideLoadingIndicator() {
        if (this.loadingIndicator) {
            this.loadingIndicator.style.display = 'none';
        }
    }

    showEndIndicator() {
        if (this.endIndicator) {
            this.endIndicator.style.display = 'block';
        }
    }

    checkForPositionRestore() {
        const hash = window.location.hash;
        if (hash && hash.startsWith('#page-')) {
            const pageProduct = hash.replace('#page-', '');
            this.restorePositionByPage(pageProduct);
        }
    }

    async restorePositionByPage(pageProduct) {
        const [targetPage, productIndex] = pageProduct.split('-').map(Number);
        const currentPage = parseInt(this.grid?.dataset.currentPage) || 1;
        
        // Si on est déjà sur la bonne page, scroll directement
        if (targetPage === currentPage) {
            this.scrollToProduct(productIndex);
            return;
        }
        
        // Si la page ciblée est dans le futur, charger jusqu'à cette page
        if (targetPage > currentPage) {
            await this.loadUpToPage(targetPage, productIndex);
        } else {
            // Si la page ciblée est dans le passé, recharger la page
            this.reloadToPage(targetPage, productIndex);
        }
    }

    async loadUpToPage(targetPage, productIndex) {
        const currentPage = parseInt(this.grid?.dataset.currentPage) || 1;
        
        for (let page = currentPage + 1; page <= targetPage; page++) {
            if (this.isLoading) {
                await this.waitForLoading();
            }
            
            await this.loadSpecificPage(page);
        }
        
        // Scroll vers le produit ciblé
        this.scrollToProduct(productIndex);
    }

    async loadSpecificPage(pageNumber) {
        if (this.isLoading) return;
        
        this.isLoading = true;
        this.showLoadingIndicator();

        try {
            const currentUrl = new URL(window.location);
            currentUrl.searchParams.set('page', pageNumber);
            currentUrl.searchParams.set('section_id', returnShopifySectionIdShort());

            const response = await fetch(currentUrl.toString());
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            const newGrid = doc.querySelector('.mm-collection-grid');
            if (newGrid) {
                // Update product positions for new products
                const newProducts = newGrid.querySelectorAll('.mm-product-card-wrapper');
                newProducts.forEach((product, index) => {
                    const globalIndex = (pageNumber - 1) * this.productsPerPage + index;
                    product.dataset.productPosition = globalIndex;
                    product.dataset.pagePosition = `${pageNumber}-${index}`;
                    
                    // Update all links in this product card
                    const links = product.querySelectorAll('a[href*="' + product.querySelector('a').href.split('/').pop() + '"]');
                    links.forEach(link => {
                        const baseUrl = link.href.split('#')[0];
                        link.href = baseUrl + '#page-' + pageNumber + '-' + index;
                    });
                });

                // Append new products to existing grid
                this.grid.innerHTML += newGrid.innerHTML;
                this.currentPage = pageNumber;
                this.grid.dataset.currentPage = this.currentPage;

                // Reinitialize product card sliders for new products
                mmSetupProductCardsSplides();
            }
        } catch (error) {
            console.error('Error loading page:', error);
        } finally {
            this.isLoading = false;
            this.hideLoadingIndicator();
        }
    }

    reloadToPage(targetPage, productIndex) {
        const currentUrl = new URL(window.location);
        currentUrl.searchParams.set('page', targetPage);
        currentUrl.hash = `#page-${targetPage}-${productIndex}`;
        window.location.href = currentUrl.toString();
    }

    scrollToProduct(productIndex) {
        const targetProduct = document.querySelector(`[data-product-position="${productIndex}"]`);
        if (targetProduct) {
            const offset = 100;
            const targetPosition = targetProduct.offsetTop - offset;
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    }

    waitForLoading() {
        return new Promise(resolve => {
            const checkLoading = () => {
                if (!this.isLoading) {
                    resolve();
                } else {
                    setTimeout(checkLoading, 100);
                }
            };
            checkLoading();
        });
    }

    // Method to handle filter changes - reset infinite scroll
    reset() {
        this.currentPage = 1;
        this.isLoading = false;
        this.hideLoadingIndicator();
        this.hideEndIndicator();
        
        // Update grid data attributes
        if (this.grid) {
            this.grid.dataset.currentPage = this.currentPage;
        }
    }

    hideEndIndicator() {
        if (this.endIndicator) {
            this.endIndicator.style.display = 'none';
        }
    }
}

// Global instance
let mmInfiniteScroll;

/*********************************************************************************************
* Scroll to the top of the page.
	*
*/

function checkScrollPosition() {	
	const scrollBtn = document.querySelector('.mm-product-grid-back-to-top');
	const scrollPosition = window.scrollY;
	const documentHeight = document.body.scrollHeight - window.innerHeight;
	const scrolledPercentage = (scrollPosition / documentHeight) * 100;

	if (scrolledPercentage > 50) {
		scrollBtn.classList.add('mm-visible');
	} else {
		scrollBtn.classList.remove('mm-visible');
	}
}

window.addEventListener('scroll', checkScrollPosition);

function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}   

/*********************************************************************************************
* Loaded Listenner
	*
*/
window.addEventListener('DOMContentLoaded', (event) => {
    checkForChanges();
    checkScrollPosition();
    // Initialize infinite scroll
    mmInfiniteScroll = new MMInfiniteScroll();
});
